import { ReloadOutlined } from "@ant-design/icons";
import {
    Button,
    Col,
    Form, Row, Tabs, Input,
    Switch
} from "antd";
import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import BackButton from "../../../commons/BackButton";
import { ROOT_URL } from "../../../constants/api";
import { nofication } from './../../../commons/Nofication';
import Upload from './../../../commons/Upload';
import AboutForm from './../../../components/form/aboutForm';
import MainLayout from "./../../../components/mainLayout";
import { authApis } from "./../../../services/authApi";
import "./index.scss";
import UploadMultiple from './../../../commons/UploadMultiple/UploadMultiple';

const { TabPane } = Tabs;
const onChange = (key) => {
    console.log(key);
};
const Register = () => {
    const [fileList, setFileList] = useState(); // single
    const [imageUrl, setImageUrl] = useState(''); // single

    const [fileListProject, setFileListProject] = useState([]); // multiple
    const [imageUrlProject, setImageUrlProject] = useState([]); // multiple
    const [idsRemove, setIdsRemove] = useState([]); // multiple
    const [imgCurrent, setImgCurrent] = useState([]); // multiple
    const [content, setContent] = useState({
        content_vi: "",
        // content_en: "",
        // content_kr: "",
        // content_cn: "",
        // content_jp: "",
    });
    const [form] = Form.useForm();
    let { id } = useParams();

    const onChangeContentValue = (lang) => {
    }

    useEffect(() => {
        if (id) {
            authApis
                .getStaticPage(id)
                .then((data) => {
                    if (data.status_code === 200) {
                        form.setFieldsValue(data.banner);
                        form.setFieldsValue({ fields: data.statices });
                        setContent({
                            content_vi: data.banner?.content_vi ?? '<p></p>',
                            // content_en: data.banner?.content_en ?? '<p></p>',
                            // content_kr: data.banner?.content_kr ?? '<p></p>',
                            // content_cn: data.banner?.content_cn ?? '<p></p>',
                            // content_jp: data.banner?.content_jp ?? '<p></p>',
                        });
                        console.log('content', content)
                        setImageUrl(data.banner?.image ? ROOT_URL + data.banner.image : '')
                        setImgCurrent(data.images);
                        setImageUrlProject(data.images);
                    } else {
                        nofication('error', 'Thất bại', 'Vui lòng kiểm tra lại thông tin !');
                    }
                })
                .catch((errors) => {
                    nofication('error', 'Thất bại', 'Không kết nối được server');
                });
        }
    }, [id]);

    const onFinish = async () => {
        const values = form.getFieldValue();
        values.logo = undefined;
        const formData = new FormData();
        for (var key in values) {
            if (key === 'content_vi' || key === 'content_en' || key === 'content_kr' || key === 'content_cn' || key === 'content_jp') {
                formData.append(key, values[key]?.editor ? values[key]?.editor.getData() : values[key]);
            } else {
                formData.append(key, values[key]);
            }
            if (key === 'fields'){
                formData.append(key, JSON.stringify(values[key]));
            }
        }
        id && formData.append('id', id);

        // xử lý upload multiple
        if (fileListProject && fileListProject.length !== 0) {
            for (let i = 0; i < fileListProject.length; i++) {
                formData.append('logo' + i, fileListProject[i])
                console.log('fileList[i]', fileListProject[i])
            }
        }
        formData.append('total', fileListProject && fileListProject.length)

        // xử lý upload single
        formData.append('logo', fileList)
        formData.append("imageUrl", imageUrl);

        formData.append('idsRemove', idsRemove)
        formData.append('type', 2)

        await authApis
            .addStaticPage(formData)
            .then((data) => {
                if (data.status_code === 200) {
                    nofication('success', 'Thành công', 'Cập nhật thành công!');
                } else {
                    nofication('error', 'Thất bại', 'Vui lòng kiểm tra lại thông tin !');
                }
            })
            .catch((errors) => {
                nofication('error', 'Thất bại', 'Không kết nối được server');
                console.log(errors)
            });
    };

    return (
        <MainLayout
            isShowActionHeader={false}
            title="Thông tin khối học"
            link="/about/"
            titleNew="Thông tin khối học"
        >
            <Form form={form} layout="vertical" onFinish={onFinish} colon={true}>
                <Row gutter={16}>
                    <Col span={24} className='pad'>
                        <div className="box-class">
                            <Tabs defaultActiveKey="1" onChange={onChange}>
                                <TabPane tab="Tiếng việt" key="1">
                                    <AboutForm lang={'vi'} onChangeContentValue={onChangeContentValue} content={content} id={id} isBanner={false}/>
                                </TabPane>
                            </Tabs>
                            <Form.Item label="Banner" colon={true}>
                                <Upload imageUrl={imageUrl} setFileList={setFileList} setImageUrl={setImageUrl} span={24} />
                            </Form.Item>
                            

                            <Form.Item label="Title quy mô phát triển" colon={true} name="title_development">
                                <Input />
                            </Form.Item>
                            <Row gutter={16}>
                                <Col span={6}>
                                    <Form.Item label="Sĩ số" colon={true} name="total_student">
                                        <Input type="number" />
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="Số lớp" colon={true} name="total_class">
                                        <Input type="number" />
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="Số khối" colon={true} name="total_block">
                                        <Input type="number" />
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="Hiển thị" name="is_show" valuePropName="checked">
                                        <Switch />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Form.Item label="Hiển thị dự án" colon={true} name="is_show_project" valuePropName="checked">
                                <Switch />
                            </Form.Item>

                            <Form.Item label="Câu lạc bộ" colon={true}>
                                <UploadMultiple imageUrl={imageUrlProject} setFileList={setFileListProject} setImageUrl={setImageUrlProject} setIdsRemove={setIdsRemove} idsRemove={idsRemove} imgCurrent={imgCurrent} fileList={fileListProject} span={24} />
                            </Form.Item>

                            <Form.Item>
                                <Row
                                    justify="space-between"
                                    style={{ marginTop: 30 }}
                                >
                                    <Col>
                                        <Button
                                            type="primary"
                                            icon={<ReloadOutlined />}
                                            htmlType="submit"
                                        >
                                            Submit
                                        </Button>
                                        <Button
                                            htmlType="reset"
                                            style={{
                                                background: "#6c757d",
                                                color: "white",
                                                marginLeft: 20,
                                            }}
                                        >
                                            Reset
                                        </Button>
                                    </Col>
                                    <Col>
                                        <BackButton/>
                                    </Col>
                                </Row>
                            </Form.Item>
                        </div>
                    </Col>
                </Row>
            </Form>
        </MainLayout>
    );
};

export default Register;
